// extracted by mini-css-extract-plugin
export default {"navBurger":"NavBurger_navBurger__Dv2dO","burger":"NavBurger_burger__Q66g8","dropMenu":"NavBurger_dropMenu__8fQWo","links":"NavBurger_links__4X597"};